module.exports = __webpack_public_path__ + "img/BannerPortabilidad1920x300.31238464.jpg";